import { DropdownDataProps } from 'common/components/Select';

const graphDateList:DropdownDataProps[] = [
  { value: 1, label: 'Тиждень' },
  { value: 2, label: 'Місяць' },
  { value: 3, label: 'Рік' },
  { value: 4, label: 'Весь час' },
];

export default graphDateList;